import { BatchType } from '../../domain/invoicing/invoicingApi'

export type BatchTypeCopy = {
  label: string
  itemNoun: string
  processingTitle: string
  completedTitle: string
  completedWithErrorsTitle: string
  completedWithWarningsTitle: string
  failedTitle: string
  successDescriptionPrefix: string
  emptyTitle: string
  emptyDescription: string
}

const copyByBatchType: Record<BatchType, BatchTypeCopy> = {
  create: {
    label: 'Batch Create',
    itemNoun: 'jobs',
    processingTitle: 'Creating invoices...',
    completedTitle: 'Batch invoice creation complete',
    completedWithErrorsTitle: 'Batch invoice creation completed with errors',
    completedWithWarningsTitle: 'Batch invoice creation completed with warnings',
    failedTitle: 'Batch invoice creation failed',
    successDescriptionPrefix: 'Successfully created',
    emptyTitle: 'No Invoices Generated',
    emptyDescription: 'No jobs had outstanding Time and Materials or Per Visit work to invoice for the selected date range.',
  },
  send: {
    label: 'Bulk Send',
    itemNoun: 'invoices',
    processingTitle: 'Sending invoices...',
    completedTitle: 'Bulk send complete',
    completedWithErrorsTitle: 'Bulk send completed with errors',
    completedWithWarningsTitle: 'Bulk send completed with warnings',
    failedTitle: 'Bulk send failed',
    successDescriptionPrefix: 'Successfully sent',
    emptyTitle: 'No Invoices Sent',
    emptyDescription: 'No invoices were sent.',
  },
  delete: {
    label: 'Bulk Delete',
    itemNoun: 'invoices',
    processingTitle: 'Deleting invoices...',
    completedTitle: 'Bulk delete complete',
    completedWithErrorsTitle: 'Bulk delete completed with errors',
    completedWithWarningsTitle: 'Bulk delete completed with warnings',
    failedTitle: 'Bulk delete failed',
    successDescriptionPrefix: 'Successfully deleted',
    emptyTitle: 'No Invoices Deleted',
    emptyDescription: 'No invoices were deleted.',
  },
  sync: {
    label: 'Bulk Sync',
    itemNoun: 'invoices',
    processingTitle: 'Syncing invoices to QuickBooks...',
    completedTitle: 'Bulk sync complete',
    completedWithErrorsTitle: 'Bulk sync completed with errors',
    completedWithWarningsTitle: 'Bulk sync completed with warnings',
    failedTitle: 'Bulk sync failed',
    successDescriptionPrefix: 'Successfully synced',
    emptyTitle: 'No Invoices Synced',
    emptyDescription: 'No invoices were synced.',
  },
}

// Used if the backend introduces a new BatchType the frontend hasn't learned about yet.
// Neutral wording so we don't mislabel the operation as something it isn't.
const genericBatchCopy: BatchTypeCopy = {
  label: 'Bulk Operation',
  itemNoun: 'items',
  processingTitle: 'Processing...',
  completedTitle: 'Bulk operation complete',
  completedWithErrorsTitle: 'Bulk operation completed with errors',
  completedWithWarningsTitle: 'Bulk operation completed with warnings',
  failedTitle: 'Bulk operation failed',
  successDescriptionPrefix: 'Successfully processed',
  emptyTitle: 'No Items Processed',
  emptyDescription: 'No items were processed.',
}

export const getBatchTypeCopy = (batchType: BatchType): BatchTypeCopy => {
  return copyByBatchType[batchType] ?? genericBatchCopy
}
